module.exports = __webpack_public_path__ + "static/media/saflogo.2f13d1e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Inc/saflogo.jpg
// module id = 1346
// module chunks = 0